import { useTranslation } from '../../i18n'
import './HowItWorks.css'

function HowItWorks() {
  const { t } = useTranslation()

  return (
    <section id="how-it-works" className="section" aria-label="How it works">
      <div className="container">
        <div className="section-title">
          <h2>{t('howItWorksTitle')}</h2>
          <p>{t('howItWorksSubtitle')}</p>
        </div>

        <div className="steps-container">
          <div className="step">
            <div className="step-number">01</div>
            <div className="step-content">
              <h3>{t('step1Title')}</h3>
              <p>{t('step1Desc')}</p>
            </div>
            <div className="step-visual start">
              <div className="visual-box">
                <div className="app-window mini">
                  <div className="window-bar">
                    <span className="dot red"></span>
                    <span className="dot yellow"></span>
                    <span className="dot green"></span>
                  </div>
                  <div className="window-content">
                    <button className="start-btn">▶ {t('startSession')}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="step">
            <div className="step-number">02</div>
            <div className="step-content">
              <h3>{t('step2Title')}</h3>
              <p>{t('step2Desc')}</p>
            </div>
            <div className="step-visual speak">
              <div className="visual-box">
                <div className="waveform">
                  {[...Array(12)].map((_, i) => (
                    <div key={i} className="wave-bar" style={{ animationDelay: `${i * 0.1}s` }}></div>
                  ))}
                </div>
                <div className="transcript-preview">
                  <span className="typing-text">{t('transcribing')}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="step">
            <div className="step-number">03</div>
            <div className="step-content">
              <h3>{t('step3Title')}</h3>
              <p>{t('step3Desc')}</p>
            </div>
            <div className="step-visual detect">
              <div className="visual-box">
                <div className="question-detect">
                  <span className="detect-label">{t('questionDetected')}</span>
                  <span className="detect-type">{t('technical')}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="step">
            <div className="step-number">04</div>
            <div className="step-content">
              <h3>{t('step4Title')}</h3>
              <p>{t('step4Desc')}</p>
            </div>
            <div className="step-visual hints">
              <div className="visual-box">
                <div className="hint-cards">
                  <div className="mini-hint answer">💡 {t('answerHint')}</div>
                  <div className="mini-hint depth">🔍 {t('depthHint')}</div>
                  <div className="mini-hint lateral">🔀 {t('lateralHint')}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="architecture-note" role="note">
          <div className="architecture-icon">🏗️</div>
          <div className="architecture-content">
            <h4>{t('architectureTitle')}</h4>
            <p>{t('architectureDesc')}</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HowItWorks
